import {
  Component,
  Input,
  computed,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';

import { Store } from '@ngrx/store';

import { selectUser } from 'src/app/core/reducers';
import { AppState } from 'src/app/reducers';
import {
  NotificationsScope,
  injectLatestNotificationsQuery,
} from 'src/app/api/queries/notification.queries';

import { Notification } from 'src/app/core/models/core.models';

@Component({
  selector: 'app-dropdown-notifications',
  templateUrl: './dropdown-notifications.component.html',
  styleUrls: ['./dropdown-notifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DropdownNotificationsComponent {
  @Input() closeMethod!: () => void;

  private readonly store = inject(Store<AppState>);

  private readonly user = this.store.selectSignal(selectUser);

  private readonly scope = computed<NotificationsScope | null>(() => {
    const user = this.user();

    return user?.id
      ? { userId: user.id, companyId: user.active_company_id }
      : null;
  });

  private readonly notificationsQuery = injectLatestNotificationsQuery(
    this.scope,
  );

  readonly notifications = computed(() => this.notificationsQuery.data() ?? []);
  readonly notificationsLoading = this.notificationsQuery.isLoading;
  readonly notificationCount = computed(() => this.notifications().length);

  trackByNotificationId(index: number, item: Notification): string | number {
    return item.fingerprint_id;
  }
}
